// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__ojZKE","obliqueLineWrap":"membershipbadge_obliqueLineWrap__1zYnu","obliqueLine":"membershipbadge_obliqueLine__26VhR"};